import { Link } from 'react-router-dom'
import type { CallLogDetail } from 'types/entity'
import { formatDateTime } from 'utils/dotNetDate'

const AVATAR_FALLBACK =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><rect width="48" height="48" fill="#e5f6ec"/><circle cx="24" cy="18" r="8" fill="#bfd4c8"/><path d="M6 47c2-10 9-15 18-15s16 5 18 15z" fill="#bfd4c8"/></svg>`,
  )

/** Port of `CreateCallLogView` + `GetCallLogData`. */
export function CallLogDetailView({ callLog }: { callLog: CallLogDetail }) {
  const agent = [callLog.AgentFirstName, callLog.AgentLastName].filter(Boolean).join(' ')

  return (
    <div className="entity-main">
      <h5>Call Log Details</h5>

      <div className="details-header">
        <span className="call-direction" title="Call">
          📞
        </span>
        <img
          className="related-avatar"
          src={callLog.ProfileImgFileName || AVATAR_FALLBACK}
          alt={callLog.PersonName}
          onError={(e) => {
            e.currentTarget.src = AVATAR_FALLBACK
          }}
        />
        <div className="grow">
          <h4 className="lead-title">
            <span className="k">Related To:</span> {callLog.PersonName || '—'}
          </h4>
          <div className="font13">
            <span className="mr-2">
              <span className="k">Mobile No.:</span> {callLog.MobileNo || '—'}
            </span>
            {callLog.EntityId != null && callLog.EntityId !== '' && (
              <span className="mr-2">
                <span className="k">Lead No.:</span>{' '}
                <Link to={`/view/lead/${callLog.EntityId}`}>{callLog.EntityId}</Link>
              </span>
            )}
            <span>
              <span className="k">Date:</span> {formatDateTime(callLog.CallEndTime) || '—'}
            </span>
          </div>
        </div>

        {callLog.RecodingUrl ? (
          <audio controls loop src={callLog.RecodingUrl} className="call-recording" />
        ) : (
          <span className="text-muted font12">No recording</span>
        )}
      </div>

      <div className="lead-content">
        <div className="detail-grid">
          <Detail label="Agent Disposition" value={callLog.AgentCallDisposition} />
          <Detail label="Agent Duration" value={callLog.AgentDuration} />
          <Detail label="Agent" value={agent} />
          <Detail label="Customer Disposition" value={callLog.CustomerCallDisposition} />
          <Detail label="Customer Duration" value={callLog.CustomerDuration} />
          <Detail label="Outcome" value={callLog.OutComeName} />
          <Detail label="Gateway" value={callLog.CallGetWay} />
          <Detail label="DNID" value={callLog.DNID} />
          <Detail label="IVR Flow" value={callLog.IVFlow} />
        </div>

        {callLog.Remarks && (
          <p className="mt-1">
            <span className="k">Remarks:</span> {callLog.Remarks}
          </p>
        )}
      </div>
    </div>
  )
}

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <div className="detail-item">
      <span className="k">{label}:</span>
      <span>{value || '—'}</span>
    </div>
  )
}
